import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';

import { GlobalPipesModule } from '@app/pipes/global-pipes.module';
import { 
  ByhoursFilterHourComponent
} from '@shared/magic-filter-bar/byhours-filter-hour/byhours-filter-hour.component';
import { TypographyDsComponent } from '@design-system/components/atoms/typography/typography.component';
import { FloatingFilterDsComponent } from '@design-system/components/organisms/floating-filter/floating-filter.component';

@NgModule({
  declarations: [
    ByhoursFilterHourComponent
  ],
  imports: [
    CommonModule,
    GlobalPipesModule,
    TranslocoModule,
    TypographyDsComponent,
    FloatingFilterDsComponent,
  ],
  exports: [
    ByhoursFilterHourComponent
  ]
})
export class ByhoursFilterHourModule { }
